import React, { PropsWithChildren, useState } from 'react';
import { Image } from '@mui/icons-material';
import { useDropzone } from 'react-dropzone';
import { Button, ButtonBase, Box } from '@mui/material';

interface Props {
  lablel?: string;
  onChange: (files: File[]) => any;
}

export const FileUpload: React.FunctionComponent<PropsWithChildren<Props>> = ({
  lablel,
  children,
  onChange,
}) => {
  const [files, setFiles] = useState<File[]>([]);

  const onDrop = (filesList: any) => {
    const files = Array.from(filesList || []) as File[];
    if (onChange) onChange(files);
    setFiles(files);
  };

  const { getInputProps, getRootProps } = useDropzone({
    onDrop,
  });

  return (
    <Box sx={{ display: 'flex' }}>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {children ? (
          <ButtonBase>{children}</ButtonBase>
        ) : (
          <Button variant="outlined">
            <Image /> <Box ml={2}>{lablel}</Box>
          </Button>
        )}
      </div>
    </Box>
  );
};
